<div class="container-fluid">
  <app-pagetitle title="Activations" [breadcrumbItems]="breadCrumbItems"></app-pagetitle>

  <div class="main-card-container">
    <div class="card">
      <div class="card-body">
        <!-- Header Section -->
        <div class="d-flex justify-content-between align-items-center mb-4">
          <h4 class="card-title mb-0">Activations</h4>
          
          <div class="d-flex align-items-center gap-2">
            <div class="dropdown" ngbDropdown>
              <button class="btn btn-light" ngbDropdownToggle>
                <i class="mdi mdi-dots-vertical"></i>
              </button>
              <div class="dropdown-menu dropdown-menu-end" ngbDropdownMenu>
                <a href="javascript:void(0);" class="dropdown-item">
                  <i class="mdi mdi-download me-2"></i>Export Activation
                </a>
              </div>
            </div>
            <button class="btn btn-light" (click)="refresh()" ngbTooltip="Refresh">
              <i class="mdi mdi-refresh"></i>
            </button>
          </div>
        </div>

        <!-- Search Box -->
        <div class="search-box mb-4">
          <div class="position-relative">
            <input type="text" 
                   class="form-control" 
                   placeholder="Search by asset tag or serial number..."
                   aria-label="Search activations by asset tag or serial number"
                   [(ngModel)]="term" 
                   (ngModelChange)="onSearch()">
            <i class="mdi mdi-magnify search-icon"></i>
          </div>
        </div>

        <!-- Loading State -->
        <div *ngIf="isLoading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- Table Section -->
        <div class="table-responsive" *ngIf="!isLoading">
          <div class="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-2 gap-2">
            <div class="text-muted small">
              Showing last {{monthsLoaded}} months of activations. Load more to pull older history if needed.
            </div>
            <div class="d-flex align-items-center gap-2">
              <button class="btn btn-outline-primary btn-sm"
                      (click)="loadMoreMonths()"
                      [disabled]="isLoading">
                Load previous {{defaultMonths}} months
              </button>
              <span *ngIf="isLoading" class="spinner-border spinner-border-sm text-primary" role="status">
                <span class="visually-hidden">Loading...</span>
              </span>
            </div>
          </div>
                   <div>
            <button style="font-weight: 700;font-size: 1.3em;" (click)="decrementPage()" *ngIf="canDecrement()">&lt;</button>
            &nbsp; page {{pageNumber + 1}} of {{numberOfPages}} &nbsp;
            <button style="font-weight: 700;font-size: 1.3em;" (click)="incrementPage()" *ngIf="canIncrement()">&gt;</button>
          </div>
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="sticky-col">Asset Tag</th>
                <th>Serial Number</th>
                <th>Location</th>
                <th>Game</th>
                <th>Money Limit</th>
                <th>Activation Key</th>
                <th>Timestamp</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of filteredPagenatedActivations">
                <td class="sticky-col">{{item.board?.assetTag}}</td>
                <td>{{item.board?.serialNumber}}</td>
                <td>{{item.board?.location?.locationName}}</td>
                <td>{{item.board?.installedGamePackage?.name}}</td>
                <td>
                  <span class="badge bg-light text-dark">
                    {{item.board?.renewalMetric}}: {{item.board?.renewalQuota}}
                  </span>
                </td>
                <td class="font-monospace">{{item.activationKey}}</td>
                <td>{{item.timeStamp | date: "MM/dd/YYYY hh:mm"}}</td>
              </tr>
            </tbody>
          </table>

          <!-- Empty State -->
          <div *ngIf="filtetedActivations.length === 0" class="text-center py-5">
            <p class="text-muted mb-0">No activations found</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
